import axios from "axios";

/**
 * Staff API client.
 *
 * Authentication uses HttpOnly cookies exclusively (access_token, refresh_token).
 * We do NOT read any token from localStorage - this prevents XSS-based token theft
 * (100-issue audit item 77, K/SEC/P0).
 *
 * `withCredentials: true` ensures the cookies are included on every cross-origin
 * request in dev and in production.
 */
export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
